module.exports = __webpack_public_path__ + "assets/static/jpg/charity_return_live.b96111877b442c49a6edbcca40c78636.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./app/pages/main/images/charity_return_live.jpg
 ** module id = 489
 ** module chunks = 1
 **/